import {routes} from "@/router";



/**
 * 根据后端菜单数据生成菜单列表
 * @param {Array} backendMenus - 后端返回的菜单数据
 * @returns {Array} - 处理后的菜单列表
 */
export function generateMenuFromBackend(backendMenus) {
  if (!backendMenus || !Array.isArray(backendMenus)) {
    return []
  }

  // 筛选出所有有 keyword 的路由（这些是需要显示在菜单中的）
  const routesWithKeyword = routes.filter(route =>
    route.meta?.keyword &&  route.isShow !== false
  )
console.log(routesWithKeyword,11111111)
  // 按照后端返回的顺序排序 过滤掉没有匹配到的菜单
  return backendMenus
    .sort((a, b) => a.sort - b.sort)  // 按 sort 排序
    .map(backendItem => {
      // 在前端路由中查找对应的路由
      const matchedRoute = routesWithKeyword.find(
        route => route.meta.keyword === backendItem.keyword
      )

      if (matchedRoute) {
        return {
          ...matchedRoute,
          meta: {
            ...matchedRoute.meta,
            title: backendItem.title, // 使用后端返回的标题
            originalTitle: matchedRoute.meta.title // 保留原始标题，备用
          }
        }
      }
      return null
    })
    .filter(item => item !== null)
}
